import { Link } from 'react-router-dom';
import type { NewsItem } from '@/types/content';
import { formatViews } from '@/utils/format';

export default function HotRanking({ items }: { items: NewsItem[] }) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-5">
      <div className="flex items-center gap-2 border-b border-background-200 pb-3">
        <span className="flex h-7 w-7 items-center justify-center rounded-md bg-accent-100 text-accent-600">
          <i className="ri-fire-fill text-lg" />
        </span>
        <h2 className="font-heading text-lg font-bold text-foreground-950">热门推荐</h2>
        <span className="ml-auto text-[11px] text-foreground-400">按点击量</span>
      </div>
      <ol className="mt-2 flex flex-col">
        {items.map((item, idx) => (
          <li key={item.id} className="border-b border-background-100 last:border-0">
            <Link to={`/detail/${item.id}`} className="group flex items-start gap-3 py-3">
              <span
                className={`mt-0.5 flex h-6 w-6 flex-none items-center justify-center rounded-md text-xs font-bold ${
                  idx < 3 ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-600'
                }`}
              >
                {idx + 1}
              </span>
              <span className="min-w-0 flex-1">
                <span className="line-clamp-2 text-sm font-medium leading-snug text-foreground-800 transition-colors group-hover:text-primary-600">
                  {item.title}
                </span>
                <span className="mt-1 flex items-center gap-1 text-[11px] text-foreground-400">
                  <i className="ri-eye-line" />
                  {formatViews(item.views)} 阅读
                </span>
              </span>
            </Link>
          </li>
        ))}
      </ol>
    </div>
  );
}